import moment from 'moment';
import {CarePlanConfigurationFeature} from '../../../../../backend/enums/care-plan-configuration-feature';
import {PosologyScheduleFormType} from '../../../../../types/schedule';
import {scheduleReadableExpression} from '../../../../functions/schedule-readable-expression';
import {ExportCarePlanTableColumnStyle} from '../base/export-care-plan-types';
import {
  RowData,
  ExportCarePlanGroupDataProcessor,
} from '../base/export-care-plan-group-data-processor';
import {translations} from '../../../../../i18n/translations';
import {safeParseJson} from '../../../../functions/safe-parse-json';

export class CommonPersonalDevelopmentPdfDataProcessor extends ExportCarePlanGroupDataProcessor {
  override async resolveTaskHeaders(firstRowData: RowData): Promise<string[]> {
    // 1. start-date
    const startHeader = this.t(translations.time_lapse.start_text);

    // 2. end-date (from schedule.endDate)
    const endHeader = this.t(translations.time_lapse.end_text);

    // 3. task
    const taskHeader = this.t(translations.export.task);

    // 4. periodicity (schedule readable expression)
    const periodicityHeader = this.t(translations.export.periodicity);

    // 5. Obs
    const obsHeader = this.t(translations.export.observations);

    return [startHeader, endHeader, taskHeader, periodicityHeader, obsHeader];
  }

  override resolveTaskRow(rowData: RowData) {
    const result: string[] = [];

    // 1. start-date
    const startDate = rowData.getEntryByFeature(CarePlanConfigurationFeature.StartsAtTime)?.value;
    result.push(startDate ? moment(startDate).format('DD/MM/YYYY') : '');

    // 2. end-date (from schedule.endDate)
    const schedule: PosologyScheduleFormType | undefined = safeParseJson(
      rowData.getEntryByFeature(CarePlanConfigurationFeature.Schedule)?.value
    );
    result.push(schedule?.endDate ? moment(schedule.endDate).format('DD/MM/YYYY') : '');

    // 3. task
    const task = rowData.getEntryByFeature(CarePlanConfigurationFeature.Name);
    result.push(this.getEntryValue(task));

    // 4. periodicity (schedule readable expression)
    const dateExpression = schedule
      ? scheduleReadableExpression({t: this.t, scheduleDefinition: schedule})
      : undefined;
    result.push(dateExpression ?? this.t(translations.export.no_repetition));

    // 5. Obs
    const obs = rowData.getEntryByFeature(CarePlanConfigurationFeature.Notes);
    result.push(this.getEntryValue(obs));

    return result;
  }

  override resolveTasksColumnStyles(
    taskHeaders: string[]
  ): ExportCarePlanTableColumnStyle | undefined {
    return {
      // start-date
      0: {cellWidth: 25},
      // end-date
      1: {cellWidth: 25},
      // task
      2: {cellWidth: 60},
      // periodicity
      3: {cellWidth: 60},
    };
  }
}
